import { type Transaction } from '../../../../../../shared/proxies/transactionsProxy'
import { TransactionType } from '../../../../../../shared/types/GlobalTranactionTypeEnum'

export function determineTextColorClass (transaction: Transaction): string | null {
  if (transaction.ppSslTransactionType === TransactionType.Return) {
    return 'text-red-500'
  } else if (transaction.amountCents > 0) {
    return 'text-emerald-600'
  } else {
    return null
  }
}
